// Core Files
import { Box, Image } from "@chakra-ui/react";
import React from "react";

// Subsection Files
import H4 from "../../Theme/Typography/H4";
import Small from "../../Theme/Typography/Small";
import { getImageURL } from "../../util/getImage";
const IMAGE_BASE_PATH = process.env.REACT_APP_DEV_IMAGE_BASE_PATH;

const placeholderImg = `${IMAGE_BASE_PATH}/ui/DummyImage/small.png`

export default function ImageGridList({
  data,
  text,
  columns,
  spacing,
  handleImageClick,
  handleImage,
  width,
  height,
  transition,
  className,
  archive,
  showArchiveImages,
  handleDrawer,
  ...rest
}) {
  return (
    <>
        {data && data?.map((item, index) => (
          <Box
            height="auto"
            width={width && width}
            key={index}
          >
            <Box
              justifyItems="center"
              display="flex"
              height={height ? height : {base:"185px",md:"270px"}}
              bg="white"
              justifyContent="space-around"
              position="relative"
              width={width && width}
              className={className && className}
            >
              <Image
                src={getImageURL(item?.image, 265, 270)}
                fallbackSrc={placeholderImg}
                alt=""
                cursor={"pointer"}
                transition={transition ? transition : "1s ease"}
                width={"auto"}
                objectFit={"contain"}
                onClick={(e) => {
                  if (handleDrawer) {
                    handleDrawer(item);
                  } else if (showArchiveImages) {
                    showArchiveImages(item?.image, item, true, index);
                  }
                }}
              />
            </Box>
            {text && (
              <Box py="2">
                <H4
                  color="color.blue"
                  lineHeight={"16px"}
                  cursor="pointer"
                  fontSize={{base:"12px",md:"14px"}}
                  style={{
                    display: '-webkit-box',
                    overflow: 'hidden',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 3,
                  }}
                  onClick={(e) => {
                    if (handleDrawer) {
                      handleDrawer(item);
                    } else if (showArchiveImages) {
                      showArchiveImages(item?.image, item, true, index);
                    }
                  }}
                >
                  {item?.title}
                </H4>
                {item?.subTitle && (
                  <Small
                    py="1"
                    marginInlineStart={"0.0rem !important"}
                  >{`${item?.subTitle}`}</Small>
                )}
              </Box>
            )}
          </Box>
        ))}
    </>
  );
}
